/*eslint complexity: ["error", 34]*/
import React, { useState } from 'react';
import { Alert, Button } from 'react-bootstrap';

import { useNavigation } from '../../../common/navigation';
import {
  GetCriticalPointDetailItemDto,
  GetExamDto,
} from '../../../common/spdCore/autogenerated/spdApiClient';
import { useSpdCore } from '../../../common/hooks/useSpdCore';

import { CriticalPointDetailsModal } from './CriticalPointDetailsModal';

interface AlertHarmfulFactorsAndCriticalPointsProps {
  exam: GetExamDto | undefined;
}

export const AlertHarmfulFactorsAndCriticalPoints: React.FC<
  AlertHarmfulFactorsAndCriticalPointsProps
> = ({ exam }) => {
  const nav = useNavigation();
  const spd = useSpdCore();
  const [showDetails, setShowDetails] = useState(false);
  const [detailItems, setDetailItems] = useState<
    GetCriticalPointDetailItemDto[]
  >([]);

  const handleShowDetails = async () => {
    if (!exam?.id) {
      return;
    }
    const result = await spd.exams.getCriticalPointDetails(exam.id);
    setDetailItems(result.items);
    setShowDetails(true);
  };

  return (
    <>
      <Alert
        variant={
          exam?.criticalPoint ||
          (!!exam?.supportingExaminationDict && exam?.articleWithAutoSupport)
            ? 'danger'
            : 'light'
        }
        className="d-flex justify-content-between align-items-center"
      >
        <div>
          {exam?.criticalPoint && (
            <>
              Wystąpiły punkty krytyczne:
              <strong> {exam?.criticalPoint}</strong>
            </>
          )}
          {exam?.criticalPoint &&
            !!exam?.supportingExaminationDict &&
            exam?.articleWithAutoSupport && <br />}
          {!!exam?.supportingExaminationDict &&
            exam?.articleWithAutoSupport && (
              <>
                {'Z powodu czynników szkodliwych zalecane są: '}
                {exam.supportingExaminationDictSynevo &&
                  exam.supportingExaminationDictSynevo.length > 0 && (
                    <div>
                      Synevo:{' '}
                      <strong>
                        {exam.supportingExaminationDictSynevo.join(', ')}
                      </strong>
                    </div>
                  )}
                {exam.supportingExaminationDictOther &&
                  exam.supportingExaminationDictOther.length > 0 && (
                    <div>
                      Pozostałe:{' '}
                      <strong>
                        {exam.supportingExaminationDictOther.join(', ')}
                      </strong>
                    </div>
                  )}
              </>
            )}
          {!exam?.criticalPoint &&
            (!exam?.supportingExaminationDict ||
              !exam?.articleWithAutoSupport) && (
              <>
                Wymagania badań pomocniczych: <strong>brak</strong>
              </>
            )}
          {exam?.hasSynevo && (
            <>
              <br />
              Wysłano zlecenie do <strong>Synevo</strong>
            </>
          )}
        </div>
        <div className="d-flex gap-2">
          {exam?.criticalPoint && (
            <Button
              onClick={() => void handleShowDetails()}
              variant="outline-danger"
            >
              Podgląd
            </Button>
          )}
          <Button
            onClick={() => void nav.examHarmfulFactorsEditor(exam?.id || '')}
            variant="outline-secondary"
          >
            Czynniki szkodliwe
          </Button>
        </div>
      </Alert>
      <CriticalPointDetailsModal
        show={showDetails}
        onHide={() => setShowDetails(false)}
        items={detailItems}
      />
    </>
  );
};
